import styled from 'styled-components';

export const StyledContainer = styled.svg`
  width: 90px;
  height: 90px;
  display: block;
`;
